import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
var CleanTextPointComponent = function (props) { return (React.createElement("span", { className: props.className + " text-point" })); };
export var TextPoint = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(CleanTextPointComponent, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 5px;\n  height: 5px;\n  background-color: ", ";\n  display: inline-block;\n  margin-left: 5px;\n  border-radius: 5px;\n"], ["\n  width: 5px;\n  height: 5px;\n  background-color: ", ";\n  display: inline-block;\n  margin-left: 5px;\n  border-radius: 5px;\n"])), function (props) { return props.color || '#ff9800'; });
var templateObject_1;
//# sourceMappingURL=TextPoint.js.map